import { gql } from '@apollo/client'

export const GET_APPOINTMENT = gql`
  query GetAppointment($id: ID!) {
    appointment: immersionAppointment(id: $id) {
      id
      conversationId
      from
      to
      chimeAttendeeData
      chimeMeetingData
      timeStatus
      hasInterlocutorJoined
      interlocutor {
        firstName
        lastName
        avatar
        phone
      }
      me {
        firstName
        lastName
        avatar
      }
    }
  }
`
